import { useRPC } from "../../../hooks/useRPC/index.js";
import { RPCs } from "@therms/rpc-gateway";
//#region src/modules/Reports/hooks/useReportEntry.ts
function useReportEntry(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Reports.GetReportEntryDetail.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.reportId
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useReportEntry };

//# sourceMappingURL=useReportEntry.js.map